import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";

export default function View({ uuid }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [ data, setData ] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([
      getData(),
    ])
    setReady(true);
  }

  async function getData() {
    await callApi('get-news-data', { uuid }).then((response) => {
      if(response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    })
  }

  useEffect(() => {
    init();
  }, []);

  if (ready && data) {

    const coverUrl = (data.coverPhoto) ? (CDN_URL + data.coverPhoto) : "";

    return (

      <div
        className="container"
        style={{
          paddingTop: "14px",
          paddingBottom: "26px"
        }}
      >

        <div className="row justify-content-center">

          <div className="col-md-10 col-lg-9">

            {/* Hero */}
            <div
              style={{
                width: "100%",
                borderRadius: "18px",
                overflow: "hidden",
                background: "#fff",
                boxShadow: "0 12px 40px rgba(0,0,0,0.08)",
                border: "1px solid rgba(0,0,0,0.06)"
              }}
            >

              {/* Cover */}
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  background: "rgba(0,0,0,0.04)"
                }}
              >

                {coverUrl ? (
                  <img
                    src={coverUrl}
                    alt={data.title || "Event"}
                    style={{
                      width: "100%",
                      height: "420px",
                      objectFit: "cover",
                      display: "block"
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "320px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "rgba(0,0,0,0.45)",
                      fontWeight: 600
                    }}
                  >
                    No cover image
                  </div>
                )}

                {/* Dark overlay for readable header */}
                <div
                  style={{
                    position: "absolute",
                    inset: "0",
                    background: "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.25) 35%, rgba(0,0,0,0.10) 60%, rgba(0,0,0,0.00) 100%)"
                  }}
                />

                {/* Header content */}
                <div
                  style={{
                    position: "absolute",
                    left: "16px",
                    right: "16px",
                    top: "14px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: "12px"
                  }}
                >
                  <div
                    style={{
                      maxWidth: "78%"
                    }}
                  >
                    <h6
                      className="main-section-title font-semi-bold"
                      style={{
                        margin: "0",
                        color: "#fff",
                        fontSize: "18px",
                        lineHeight: "1.25",
                        textShadow: "0 8px 24px rgba(0,0,0,0.35)"
                      }}
                    >
                      {data.title}
                    </h6>

                    <div
                      style={{
                        marginTop: "8px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "6px 10px",
                        borderRadius: "999px",
                        background: "rgba(255,255,255,0.14)",
                        border: "1px solid rgba(255,255,255,0.18)",
                        backdropFilter: "blur(10px)"
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.9)",
                          display: "inline-block"
                        }}
                      />
                      <span
                        className="font-semi-bold"
                        style={{
                          fontSize: "12px",
                          color: "rgba(255,255,255,0.92)"
                        }}
                      >
                        {formatDate(data.dateCreated)}
                      </span>
                    </div>
                  </div>

                  <div
                    className="text-end"
                    style={{
                      flexShrink: 0,
                      paddingTop: "2px"
                    }}
                  >
                    <div
                      style={{
                        padding: "7px 10px",
                        borderRadius: "12px",
                        background: "rgba(255,255,255,0.10)",
                        border: "1px solid rgba(255,255,255,0.14)",
                        backdropFilter: "blur(10px)"
                      }}
                    >
                      <div
                        className="font-semi-bold"
                        style={{
                          fontSize: "12px",
                          color: "rgba(255,255,255,0.9)"
                        }}
                      >
                        Event
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: "rgba(255,255,255,0.75)",
                          marginTop: "2px"
                        }}
                      >
                        Details
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* Body */}
              <div
                style={{
                  padding: "18px 16px 18px 16px"
                }}
              >

                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    background: "rgba(0,0,0,0.06)",
                    marginBottom: "14px"
                  }}
                />

                <div
                  className=""
                  style={{
                    width: "100%",
                    padding: "0",
                    overflow: "hidden",
                    fontSize: "14px",
                    lineHeight: "1.7",
                    color: "rgba(0,0,0,0.78)"
                  }}
                  dangerouslySetInnerHTML={{ __html: data.body }}
                >
                </div>

              </div>

            </div>

            {/* Subtle footer spacing */}
            <div style={{ height: "16px" }} />

          </div>

        </div>

      </div>

    );

  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
